import React, {Component, Fragment} from 'react';
import LandingHeader from './../Landing/LandingHeader.js';
import Footer from '../Footer';
import {Link, withRouter} from 'react-router-dom';
import DeliveryData from './DeliveryData.js';
import DeliveredData from './DeliveredData.js';
import DeliveryDetails from './DeliveryDetails.js';
import BillingDetails from './BillingDetails.js';
import {connect} from "react-redux";

class DeliveryAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stepCount: 1,
      // isStepExpress: false, // это будет из пропсов прошлйо формы идти чтобы знать експресс форма или нет
      maxStepExpress: 3,
      maxStepOnDate: 4
    }
  }

  handleNextStep = () => {
    const {stepCount, maxStepExpress, maxStepOnDate} = this.state;
    const {deliveryAddress} = this.props;
    if((deliveryAddress.express_delivery && stepCount < maxStepExpress) || (!deliveryAddress.express_delivery < maxStepOnDate)) {
      this.setState({
        stepCount: stepCount+1
      });
    }
  };

  handlePrevStep = () => {
    const {stepCount} = this.state;
    if(stepCount !== 1) {
      this.setState({
        stepCount: stepCount-1
      });
    }
  };

  handleBackDeliveryAddress = () => {
    const {history} = this.props;
    history.push( '/delivery-address');
  };

  render() {
    const {handleNextStep, handlePrevStep} = this;
    const {stepCount} = this.state;
    const {cart, deliveryAddress, deliveryData} = this.props;
    const isStepExpress = deliveryAddress && JSON.parse(deliveryAddress.express_delivery);
    // console.log(deliveryAddress.express_delivery)
    return (
      <Fragment>
        { cart.length !== 0 && deliveryAddress !== null ? (
          <div className="body">
            <LandingHeader/>
            <main className="index-shop">

              {(isStepExpress && stepCount === 1) || (!isStepExpress && stepCount === 1) ? (
                <div className="delivery-step-1">
                  <DeliveryData/>
                  <button className="shop-btn shop-btn--prev shop-btn--common shop-btn-left--common" onClick={this.handleBackDeliveryAddress} />
                  <button className="shop-btn shop-btn--next shop-btn--common shop-btn-right--common" onClick={handleNextStep} disabled={deliveryData.error_message ? true : false} />
                </div>
              ) : ( '' )}

              {(isStepExpress && stepCount === 2) || (!isStepExpress && stepCount === 2) ? (
                <div className="delivery-step-1">
                  <BillingDetails handleNextStep={handleNextStep}/>
                  <button className="shop-btn shop-btn--prev shop-btn--common shop-btn-left--common" onClick={handlePrevStep} />
                </div>
              ) : ( '' )}

              {(!isStepExpress && stepCount === 3) ? (
                <div className="delivery-step-1">
                  {/*delivery-step-3 этот шаг когда не экспресс*/}
                  <DeliveryDetails handleNextStep={handleNextStep}/>
                  <button className="shop-btn shop-btn--prev shop-btn--common shop-btn-left--common" onClick={handlePrevStep} />
                </div>
              ) : (
                ''
              )}

              {(isStepExpress && stepCount === 3) || (!isStepExpress && stepCount === 4) ? (
                <div className="delivery-step-1">
                  <DeliveredData/>
                  <button className="shop-btn shop-btn--prev shop-btn--common shop-btn-left--common" onClick={handlePrevStep} />
                </div>
              ) : ( '' )}
            </main>
            <Footer/>
          </div>
        ) : (
          <Fragment>
            <div className="body">
              <LandingHeader/>
              <main className="index-shop">
                <h1 className="not-found">Einkaufswagen ist leer</h1>
                <div className="not-found__return-wrap">
                  <Link className="not-found__return" to="/shop">Return to shop</Link>
                </div>
              </main>
              <Footer/>
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default withRouter(connect((state) => {
  return {
    cart: state.cart,
    deliveryAddress: state.delivery.deliveryAddress,
    deliveryData: state.delivery.deliveryData
  }
}, null)(DeliveryAddress));


// WEBPACK FOOTER //
// ./src/components/DeliverySteps/DeliverySteps.js